var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"d-flex flex-row",staticStyle:{"height":"100%","margin":"0px","padding":"0px","min-height":"inherit"},attrs:{"fluid":""}},[_c('agency-profile-left-section',{staticClass:"hidden-sm-and-down"}),_c('agency-profile-volunteers-section')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }